import {ImbaDocument} from 'imba/program'

let imbac = null

def createDoc uri,lang,v,body
	let cls = ImbaDocument
	if imbac and imbac.program
		cls = imbac.program.ImbaDocument
	new cls(uri,'imba',0,body)
	
def req path
	let prev = globalThis.exports
	let ex = globalThis.exports = {}
	let ic = globalThis.imbac
	try
		globalThis.importScripts(path)
	catch e
		globalThis.importScripts("/static/imba.compiler.js")

	if globalThis.imbac != ic
		ex = globalThis.imbac
		
	if ex.default
		ex = ex.default

	globalThis.exports = prev
	return ex

def ImbaWorker ctx, options
	this.ctx = ctx
	this.options = options
	this.models = {}
	this.documents = {}

	let res = req(options.compilerPath or "/static/imba.compiler.js")
	if res
		globalThis.imbac = imbac = res

	return this

ImbaWorker.prototype = {

	def getModel uri
		# console.log 'get model with uri',uri
		for item in ctx.getMirrorModels!
			let match = item.uri.toString!
			# console.log 'mirror',match
			if match == uri
				# console.log 'found matching model!',item,uri
				return item
		return null

	def getDocument uri
		let model = getModel(uri)
		return null unless model

		let body = model.getValue!
		let doc = documents[uri] ||= createDoc(uri,'imba',0,body)
		doc.overwrite(body) unless doc.content == body
		return doc

	def getSemanticTokens uri
		if let doc = getDocument(uri)
			return doc.getEncodedSemanticTokens!
		# console.log 'get semantic tokens',uri,doc,getModel(uri),tokens
		# let results = tokens.map do [$1.offset,$1.value.length]
		# return results

	def getDiagnostics uri
		let out = {errors: []}
		let model = getModel(uri)
		# console.log 'calling getDiagnostics in worker',uri,model,model or ctx.getMirrorModels!
		return Promise.resolve(out) unless model
		let code = model.getValue!
		return Promise.resolve(out) unless (/\S/).test(code)

		try
			let res = imbac.compile(code,{sourcePath: uri, hmr: true})
			# console.log 'did compile',res,uri
			out.css = res.css
			out.js = res.js
			out.id = res.sourceId

		catch e
			let token = e.token
			console.log 'error on get diagnostics',e,token
			out.errors.push([token._loc,token._len,e.message])

		return Promise.resolve(out)

	def getCompiledCode uri
		let model = getModel(uri)
		return Promise.resolve({}) unless model

		let code = model.getValue
		
		if (/\S/).test(code)
			let out = imbac.compile(code,{})
			return Promise.resolve(String(out))
		else
			return Promise.resolve({})

	def compile code, options = {}
		# console.log "compile imba with options",options
		options.resolve = do({path})
			# if !path.match(/^(https?\:\/\/|\.)/)
			#	return "/node_modules/{path}"
			return path

		let out = imbac.compile(code,options)
		return String(out)

}
# export def create ctx, data
# 	let item = new ImbaWorker(ctx, data)
# 	# console.log 'creating worker!',item
# 	return item

global.define do
	return {
		create: do(ctx,data) return new ImbaWorker(ctx, data)
	}